<div class="d-flex flex-column justify-content-center align-items-center w-100">
	{{ 'general.redirecting' | translate }}
</div>
